export const ShopConstants = {
    SHOP_ADDED_REQUEST:'SHOP_ADDED_REQUEST',
    SHOP_ADDED_SUCCESS:'SHOP_ADDED_SUCCESS',
    SHOP_ADDED_FAILURE:'SHOP_ADDED_FAILURE',  

    GET_SHOP_AND_SHOPKEEPR_LIST_REQUEST: 'GET_SHOP_AND_SHOPKEEPR_LIST_REQUEST',
    GET_SHOP_AND_SHOPKEEPR_LIST_SUCCESS: 'GET_SHOP_AND_SHOPKEEPR_LIST_SUCCESS',
    GET_SHOP_AND_SHOPKEEPR_LIST_FAILURE: 'GET_SHOP_AND_SHOPKEEPR_LIST_FAILURE',

    GET_SHOPKEEPR_REQUEST: 'GET_SHOPKEEPR_REQUEST',
    GET_SHOPKEEPR_SUCCESS: 'GET_SHOPKEEPR_SUCCESS',
    GET_SHOPKEEPR_FAILURE: 'GET_SHOPKEEPR_FAILURE',
    
    SHOP_UPDATE_REQUEST:'SHOP_UPDATE_REQUEST',
    SHOP_UPDATE_SUCCESS:'SHOP_UPDATE_SUCCESS',
    SHOP_UPDATE_FAILURE:'SHOP_UPDATE_FAILURE',  
        
};
